goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Apps$default");
shadow.js.shim.module$$carbon$icons_react$es$Apps$default = shadow.js.require(346, {}).default;
